


























































































































































































































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Consulta } from '../../../../back/src/entity/Consulta';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';
import { PressaoArterial } from '../../../../back/src/entity/PressaoArterial';
import {
  Edema,
  ApresentacaoFetal,
  PosicaoFetal,
  MovimentoFetal,
  ConsultaAlterarQueixasCondutasPrivadaFormData,
} from '../../../../back/src/types';
import {
  edemaStrings,
  apresentacaoFetalStrings,
  posicaoFetalStrings,
  movimentoFetalStrings,
} from '../../utils/constants';
import { calculoIdadeGestacional, calculaImc } from '../../utils/functions';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import ThePressoesArteriaisDadosDialog from '../pressoes_arteriais/ThePressoesArteriaisDadosDialog.vue';
import ConsultasQueixasCondutasLer from './ConsultasQueixasCondutasLer.vue';
import Confirmar from '../Confirmar.vue';

export default Vue.extend({
  name: 'TheConsultasDadosIndividual',
  components: {
    IfEmptyTextPrintNA,
    ThePressoesArteriaisDadosDialog,
    ConsultasQueixasCondutasLer,
    Confirmar,
  },
  props: {
    consulta: {
      type: Object as () => Consulta,
    },
    extraInfo: {
      type: Boolean,
      default: false,
    },
    showAlterarQueixasCondutasPrivadas: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogPressaoArterial: false,
      pressaoArterialSelecionada: null,
      collapseQueixasCondutas: false,
      collapsePedidosExames: false,
      form: {
        queixasCondutasPrivada: this.consulta.queixas_condutas_privada,
      },
    };
  },
  computed: {
    usuario() {
      return this.$store.getters.usuario;
    },
    disabledAlterarQueixasCondutasPrivadas() {
      return !(this.usuario.grupo.alias === 'admin'
        || this.consulta.started_by === this.usuario.id
        || this.consulta.ended_by === this.usuario.id
      );
    },
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    idadeGestacional() {
      return calculoIdadeGestacional(
        this.consulta.gestacao,
        this.consulta.started,
        true,
      );
    },
    pesoKg(): string {
      if (this.consulta.peso_gramas) {
        const pesoKg = this.consulta.peso_gramas / 1000;
        return `${new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 1,
        }).format(pesoKg)} kg`;
      }
      return '';
    },
    pressoesArteriaisSorted(): PressaoArterial[] {
      return _.sortBy(this.consulta.pressoes_arteriais, el => (el.created));
    },
    gestante() {
      return !!this.consulta.gestacao;
    },
    labelFreqCardiaca() {
      return this.gestante ? 'Freq. cardíaca materna' : 'Freq. cardíaca';
    },
    gemelar() {
      return this.gestante ? this.consulta.gestacao.gestacao_gemelar : false;
    },
    flagPa() {
      return this.gestante ? this.consulta.gestacao.flag_pa : false;
    },
    resultadosDeExames(): ResultadoDeExame[] {
      return _.filter(
        this.consulta.resultados_de_exames as ResultadoDeExame[],
        resultado => (!resultado.deleted),
      );
    },
  },
  methods: {
    calculaImc,
    edema(edema: Edema): string {
      if (_.has(edemaStrings, edema)) {
        return edemaStrings[edema];
      }
      return '';
    },
    apresentacaoFetal(apresentacaoFetal: ApresentacaoFetal): string {
      if (_.has(apresentacaoFetalStrings, apresentacaoFetal)) {
        return apresentacaoFetalStrings[apresentacaoFetal];
      }
      return '';
    },
    posicaoFetal(posicaoFetal: PosicaoFetal): string {
      if (_.has(posicaoFetalStrings, posicaoFetal)) {
        return posicaoFetalStrings[posicaoFetal];
      }
      return '';
    },
    movimentoFetal(movimentoFetal: MovimentoFetal): string {
      if (_.has(movimentoFetalStrings, movimentoFetal)) {
        return movimentoFetalStrings[movimentoFetal];
      }
      return '';
    },
    abreDialogPressaoArterial(pressaoArterial: PressaoArterial) {
      this.pressaoArterialSelecionada = pressaoArterial;
      this.dialogPressaoArterial = true;
    },
    async alterarQueixasCondutasPrivadas() {
      if (await this.confirmar.open(
        `${this.form.queixasCondutasPrivada ? 'Trancar' : 'Abrir'} queixas e condutas`,
        `Tem certeza que deseja tornar as queixas e condutas ${this.form.queixasCondutasPrivada ? 'privadas' : 'abertas'}?`,
      ) === false) {
        this.form.queixasCondutasPrivada = this.consulta.queixas_condutas_privada;
        return;
      }
      const formData: ConsultaAlterarQueixasCondutasPrivadaFormData = {
        id: this.consulta.id,
        queixas_condutas_privada: this.form.queixasCondutasPrivada,
      };
      try {
        const res = await Requester.consulta.consultaAlterarQueixasCondutasPrivada(
          this.consulta.id,
          formData,
        );
        const consulta = res.data;
        this.$emit('consulta-alterada', consulta);
      } catch (err) {
        this.$root.$emit('requestError', err);
      }
    },
  },
});
